import { useState } from 'react';
import { Button } from '@startupquickstart/frontend';
import { Copy, Check } from 'lucide-react';

interface JsonViewerProps {
  data: unknown;
  maxHeight?: string;
}

/**
 * Component for displaying formatted JSON with syntax highlighting
 * Includes copy-to-clipboard functionality
 */
export function JsonViewer({ data, maxHeight = '600px' }: JsonViewerProps) {
  const [copied, setCopied] = useState(false);

  const jsonString = JSON.stringify(data, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="relative">
      <div className="absolute top-2 right-2 z-10">
        <Button
          variant="outline"
          size="sm"
          onClick={handleCopy}
          className="bg-background/95 backdrop-blur"
        >
          {copied ? (
            <>
              <Check className="h-4 w-4 mr-1" />
              Copied
            </>
          ) : (
            <>
              <Copy className="h-4 w-4 mr-1" />
              Copy
            </>
          )}
        </Button>
      </div>
      <pre
        className="bg-muted rounded-xl p-4 overflow-auto text-xs font-mono border"
        style={{ maxHeight }}
      >
        <code className="text-foreground">{jsonString}</code>
      </pre>
    </div>
  );
}
